var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssignBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#CDF3C6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2 8.2C9.20589 8.2 8.4 9.00589 8.4 10C8.4 10.9941 9.20589 11.8 10.2 11.8C11.1941 11.8 12 10.9941 12 10C12 9.00589 11.1941 8.2 10.2 8.2ZM7.2 10C7.2 8.34315 8.54315 7 10.2 7C11.8568 7 13.2 8.34315 13.2 10C13.2 11.6568 11.8568 13 10.2 13C8.54315 13 7.2 11.6568 7.2 10ZM17.8243 10.7757C18.0586 11.0101 18.0586 11.39 17.8243 11.6243L15.4243 14.0243C15.19 14.2586 14.8101 14.2586 14.5758 14.0243L13.3757 12.8243C13.1414 12.59 13.1414 12.21 13.3757 11.9757C13.61 11.7414 13.99 11.7414 14.2243 11.9757L15 12.7515L16.9758 10.7757C17.2101 10.5414 17.59 10.5414 17.8243 10.7757ZM7.3216 14.4037C8.08453 13.8951 9.10396 13.6 10.2 13.6C11.296 13.6 12.3155 13.8951 13.0784 14.4037C13.8371 14.9096 14.4 15.6742 14.4 16.6C14.4 16.9314 14.1314 17.2 13.8 17.2C13.4686 17.2 13.2 16.9314 13.2 16.6C13.2 16.2003 12.9569 15.765 12.4127 15.4022C11.8727 15.0422 11.0922 14.8 10.2 14.8C9.30782 14.8 8.52725 15.0422 7.98724 15.4022C7.44304 15.765 7.2 16.2003 7.2 16.6C7.2 16.9314 6.93137 17.2 6.6 17.2C6.26863 17.2 6 16.9314 6 16.6C6 15.6742 6.56285 14.9096 7.3216 14.4037Z",
    fill: "#0A772D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignBg);
export default __webpack_public_path__ + "static/media/AssignBG.af57785853794690600e105dcee72efc.svg";
export { ForwardRef as ReactComponent };